import { createApi } from "@reduxjs/toolkit/query/react";
import RtkBaseQueryWithReauth from "./RtkBaseQueryWithReauth";
import ApiPath from "./ConstantApi";
import Config from "./../Config";

export const RechargeService = createApi({
  reducerPath: "RechargeService",
  baseQuery: RtkBaseQueryWithReauth(Config.BASE_URL),
  tagTypes: [],
  endpoints: (builder) => ({
    mobileLookup: builder.mutation({
      query: (body: any) => ({
        url: `${ApiPath.mobileLookup}`,
        method: "POST",
        body,
      }),
    }),
    countryWiseAllProvider: builder.mutation({
      query: (body: any) => ({
        url: `${ApiPath.countryWiseAllProvider}`,
        method: "POST",
        body,
      }),
    }),

    mobileNoValidate: builder.mutation<any, void>({
      query: (body) => ({
        url: `${ApiPath.mobileNoValidate}`,
        method: "POST",
        body: body,
      }),
    }),
  }),
});

export const {
  useMobileLookupMutation,
  useCountryWiseAllProviderMutation,
  useMobileNoValidateMutation,
} = RechargeService;
